var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":_vm.height,"width":_vm.width,"elevation":"0"}},[_c('div',{ref:"container",staticClass:"vue-bpmn-diagram-container"})])}
var staticRenderFns = []

export { render, staticRenderFns }